<template>
  <Modal title="重置密码" v-model="visible">
    <Form ref="recordForm" class="form"
          :model="formData" :rules="recordRule"
          :label-width="80">
      <Row>
        <Col :span="22">
        <Form-item label="新密码" prop="recordingContent">
          <Input v-model="formData.password"></Input>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="reset">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'ResetPassWordModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      classinAccout: {
        type: String
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        formData: {
          classinAccout: '',
          password: '',
        },
        loadingAdd: false,
        recordRule: {
          password: [
            { type: 'string', required: true, message: '密码不能为空', trigger: 'blur' },
          ],
        },
      }
    },
    methods: {
      reset () {
        let self = this
        self.loadingAdd = true
        self.$refs.recordForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingAdd = false
            return
          }
          let params = self.formData
          self.$http.post('/bookClassin/reSetPassword', {classinAccout: params.classinAccout, password: params.password}).then(function (res) {
            self.loadingAdd = false
            if (res) {
              self.$Message.success('添加成功!')
              self.visible = false
              return
            }
          })
        })
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.formData.password = ''
        }
        if (!val) {
          this.$emit('on-close', val)
        }
        this.$emit('input', val)
      },
      classinAccout (val) {
        if (val) {
          this.formData.classinAccout = val
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ResetPassWordModal.vue?3e1da772